import DatePicker from "react-datepicker";
import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Multiselect } from "multiselect-react-dropdown";
import { axiosInstnace } from "../../../util/util";
import { endPoints } from "../../../config";

const Modal = ({ isShowing, hide, rates, updateRate }) => {
  const [amount, handleamount] = useState("");
  const [invoiceamount, handleinvoiceamount] = useState("");
  const [utrnumber, handleutrnumber] = useState("");
  const [invoicenumber, handleinvoicenumber] = useState("");
  const [tdsamount, handletdsamount] = useState("0");
  const [otherdeduction, handleotherdeduction] = useState("0");
  const [paymentmode, handlepaymentmode] = useState("");
  const [date, handledate] = useState("");
  const [bank, handlebank] = useState("");
  const [remarks, handleRemarks] = useState("");

  useEffect(() => {
    handleinvoiceamount(rates.totalamount);
    handleinvoicenumber(rates.invoiceno);
    handleamount(rates.totalamount);
  }, []);
  useEffect(() => {
    handleamount((rates.totalamount - tdsamount - otherdeduction).toFixed(2));
  }, [tdsamount, otherdeduction]);
  const closePopup = () => {
    hide();
    handleCount(1);
  };

  const updateRates = async (e) => {
    e.preventDefault();
    if (
      !utrnumber.trim() ||
      !amount ||
      !date ||
      !paymentmode.trim() ||
      !bank.trim() ||
      !remarks.trim()
    ) {
      toast.error("All the fields are mandatory", {
        position: toast.POSITION.BOTTOM_CENTER,
        hideProgressBar: true,
        toastId: "1",
        autoClose: false,
      });
      return;
    }
    const params = {
      transaction: {
        utrnumber,
        paymentmode,
        email: rates.email,
        tdsamount,
        otherdeduction,
        amount,
        bank,
        date,
        remarks,
      },
      status: "Paid",
      invoiceno: rates.invoiceno,
    };
    let result = await axiosInstnace.post(endPoints.updateinvoice, params);
    window.location.reload(true);
  };

  return isShowing ? (
    <div>
      <div className="modal-overlay">
        <div
          className="modal-wrapper thankyou-popup"
          aria-modal
          aria-hidden
          tabIndex={-1}
          role="dialog"
        >
          <div className="modal">
            <div className="modal-head-cross rate-modal">
              <button
                type="button"
                className="modal-close-button"
                onClick={closePopup}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="editNonFct-header modal-header">
                <h4 className="popup-head rqst-head fct-head modal-title">
                  Edit Payout Details
                </h4>
              </div>
              <div className="editNonFct-modal modal-body">
                <div className="bg-white">
                  <form className="form-group">
                    <div className="popupCampaign-container">
                      <div className="campaign-input master-inputs nonFct">
                        <div className="input-tag signup-tag clearfix fct-input">
                          <label className="static-value">Invoice No</label>
                          <input
                            name="stationName"
                            type="text"
                            className="form-control"
                            value={invoicenumber}
                            readOnly={true}
                          />
                        </div>
                      </div>

                      <div className="campaign-input master-inputs nonFct">
                        <div className="input-tag signup-tag clearfix fct-input">
                          <label className="static-value">UTR No</label>
                          <input
                            name="stationName"
                            type="text"
                            className="form-control"
                            value={utrnumber}
                            onChange={(e) => {
                              handleutrnumber(e.target.value);
                            }}
                          />
                        </div>
                      </div>
                      <div className="campaign-input master-inputs nonFct">
                        <div className="input-tag signup-tag clearfix fct-input">
                          <label className="static-value">Payment Mode</label>
                          <input
                            name="trafficUpdate"
                            type="text"
                            className="form-control"
                            value={paymentmode}
                            onChange={(e) => {
                              handlepaymentmode(e.target.value);
                            }}
                          />
                        </div>
                      </div>
                      <div className="campaign-input master-inputs nonFct">
                        <div className="input-tag signup-tag clearfix fct-input">
                          <label className="static-value">Invoice Amount</label>
                          <input
                            name="weatherUpdate"
                            type="number"
                            disabled
                            className="form-control"
                            value={invoiceamount}
                          />
                        </div>
                      </div>
                      <div className="campaign-input master-inputs nonFct">
                        <div className="input-tag signup-tag clearfix fct-input">
                          <label className="static-value">TDS Deductions</label>
                          <input
                            name="weatherUpdate"
                            type="number"
                            className="form-control"
                            value={tdsamount}
                            onChange={(e) => {
                              handletdsamount(e.target.value);
                            }}
                          />
                        </div>
                      </div>
                      <div className="campaign-input master-inputs nonFct">
                        <div className="input-tag signup-tag clearfix fct-input">
                          <label className="static-value">
                            Other Deductions
                          </label>
                          <input
                            name="weatherUpdate"
                            type="number"
                            className="form-control"
                            value={otherdeduction}
                            onChange={(e) => {
                              handleotherdeduction(e.target.value);
                            }}
                          />
                        </div>
                      </div>
                      <div className="campaign-input master-inputs nonFct">
                        <div className="input-tag signup-tag clearfix fct-input">
                          <label className="static-value">Amount</label>
                          <input
                            name="weatherUpdate"
                            type="number"
                            className="form-control"
                            value={amount}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="campaign-input master-inputs nonFct">
                        <div className="input-tag signup-tag clearfix fct-input">
                          <label className="static-value">Bank</label>
                          <input
                            name="stockUpdate"
                            type="text"
                            className="form-control"
                            value={bank}
                            onChange={(e) => {
                              handlebank(e.target.value);
                            }}
                          />
                        </div>
                      </div>
                      <div className="campaign-input master-inputs nonFct">
                        <div className="input-tag signup-tag clearfix fct-input">
                          <label className="static-value">Date</label>
                          <div style={{ width: "100%" }}>
                            <DatePicker
                              selected={date}
                              onChange={(date) => handledate(date)}
                              dateFormatCalendar={"MMM yyyy"}
                              placeholderText=" Transaction Date"
                              maxDate={new Date()}
                              isClearable
                            />
                          </div>
                        </div>
                      </div>
                      <div className="campaign-input master-inputs nonFct">
                        <div className="input-tag signup-tag clearfix fct-input">
                          <label className="static-value">Remarks</label>
                          <input
                            name="stockUpdate"
                            type="text"
                            className="form-control"
                            value={remarks}
                            onChange={(e) => {
                              handleRemarks(e.target.value);
                            }}
                          />
                        </div>
                      </div>
                      <div className="create-camp nonfct-submit">
                        <button onClick={updateRates}>SUBMIT</button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="modal-footer cost_button">
         <button className="cncl">Cancel</button>
         <button className="procd">Ok</button>
        </div> */}
        </div>
      </div>
      <ToastContainer />
    </div>
  ) : null;
};

export default Modal;



// WEBPACK FOOTER //
// ./web/components/admin/dsa_management/addpayoutdetails.js